const ShawContract = window.ShawContract || {};
const preferredMeasurementSystemJSON = document.getElementById('preferredMeasurementSystem').value;
const preferredMeasurementSystemObject = preferredMeasurementSystemJSON && JSON.parse(preferredMeasurementSystemJSON);

ShawContract.preferredMeasurementSystem = preferredMeasurementSystemObject;
window.ShawContract = ShawContract;